import React, { useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

// components
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { InputComponent } from 'baseComponents/InputComponent';
import { FilterRowGroup } from '../FilterRowGroup';

// types
import { AttributeType } from 'types/create-campaign';

// store
import {
  useCreateNewAudienceActions,
  useCreateNewAudienceStore,
} from 'store/CreateNewAudienceStore';

// helpers
import { convertAudienceToBrazeFormat } from 'helpers/create-audience';

// styles
import './createAudienceForm.scss';
import { TextComponent } from 'baseComponents/TextComponent';

interface Props {
  attributesList: AttributeType[];
  calculateAudience: (audienceFilters: any) => void;
  smsEstimation?: number;
  pushEstimation?: number;
}

export const CreateAudienceForm: React.FC<Props> = (props) => {
  const [estimateBtnClicked, setEstimatedBtnClicked] = useState<boolean>(false);

  // zustand store
  const newAudienceName = useCreateNewAudienceStore((state) => state.name);
  const { setEstimatedAudience } = useCreateNewAudienceActions();

  const newAudienceFilters = useCreateNewAudienceStore(
    (state) => state.audienceFilters
  );
  const { addFiltersGroup, setName: setNewAudienceName } =
    useCreateNewAudienceActions();

  const handleAddFiltersGroup = () => {
    setEstimatedBtnClicked(false);
    addFiltersGroup();
    setEstimatedAudience({
      sms: null,
      push: null,
    });
  };

  const fielduuid = useMemo(() => uuidv4(), []);

  return (
    <>
      <div className='audience-name'>
        <InputComponent
          value={newAudienceName}
          onChange={(e) => setNewAudienceName(e.target.value)}
          labelValue='Audience name'
        />
      </div>
      {newAudienceFilters.map((item: any, index: number) => {
        return (
          <FilterRowGroup
            key={fielduuid + index}
            attributesList={props.attributesList}
            filterGroup={item}
            setEstimatedBtnClicked={setEstimatedBtnClicked}
          />
        );
      })}
      <div className='filter-buttons'>
        <ButtonComponent
          label='+AND filter'
          onClick={handleAddFiltersGroup}
          size='middle'
          appereance='secondary'
          fullWidth
        />
      </div>
      <div className='calculate-audience-section'>
        <ButtonComponent
          label='Calculate audience'
          onClick={() => {
            setEstimatedBtnClicked(true);
            props.calculateAudience(
              convertAudienceToBrazeFormat(newAudienceFilters)
            );
          }}
          size='middle'
          appereance='secondary'
          fullWidth
        />
      </div>
      <div className='calculated-audience-row'>
        {estimateBtnClicked &&
          (props.smsEstimation || props.pushEstimation) && (
            <>
              <TextComponent
                text={`Estimated audience for SMS: ${props.smsEstimation || '0'}`}
                center
                size='small'
                weight='extra-bold'
                opacity={true}
              />
              <TextComponent
                text={`Estimated audience for Push: ${props.pushEstimation || '0'}`}
                center
                size='small'
                weight='extra-bold'
                opacity={true}
              />
            </>
          )}
      </div>
    </>
  );
};
